import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/accounts/pages/Accounts'
import { AccountsRoutePathsEnum } from '@/modules/accounts/routes/accountsRouteConfig.types'

export const ACCOUNTS_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: AccountsRoutePathsEnum.ACCOUNTS,
  },
]
